import { HTTPv2, Service } from '@/services/config'
import { removePropertyEmpty } from '@/utils'
import { AxiosResponse } from 'axios'

class PrecificationAttachedServiceV2 extends Service {
  path = 'precificacaoanexo'

  constructor() {
    super(HTTPv2)
  }

  async sendFile(formData?: any): Promise<AxiosResponse> {
    const httpResponse = await this.httpClient.post(`${this.path}`, formData)
    return httpResponse
  }

  async getPricingAttachment(params?: any): Promise<AxiosResponse> {
    const httpResponse = await this.httpClient.get(`${this.path}`, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async downloadPricingAttachment(id?: any): Promise<AxiosResponse> {
    const httpResponse = await this.httpClient.get(`${this.path}/baixar`, {
      params: { arquivoId: id }
    })
    return httpResponse
  }

  async deletePricingAttachment(id?: any): Promise<AxiosResponse> {
    const httpResponse = await this.httpClient.delete(this.path, {
      params: { arquivoId: id }
    })
    return httpResponse
  }
}

export const precificationAttachedServiceV2 =
  new PrecificationAttachedServiceV2()
